import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: { accessToken: null, user: null, role: null },
  reducers: {
    setCredentials: (state, action) => {
      const { access_token: accessToken, user, role, refresh_token: refreshToken } = action.payload;

      state.accessToken = accessToken;
      state.user = user;
      state.role = role;

      // Store refresh_token in localStorage for token refresh
      if (refreshToken) {
        localStorage.setItem("refreshToken", refreshToken);
      }
    },
    logOut: (state) => {
      state.user = null;
      state.accessToken = null;
      state.role = null;

      // Clear refresh_token from localStorage
      localStorage.removeItem("refreshToken");
    },
  },
});

export const { setCredentials, logOut } = authSlice.actions;

export default authSlice.reducer;
export const selectCurrentUser = (state) => state.auth.user;
export const selectRole = (state) => state.auth.role;
export const selectCurrentToken = (state) => state.auth.accessToken;
export const selectAuth = (state) => state.auth;
